import React from "react";
import { AboutUsContainer } from "./AboutUs.style";
import Header from "Components/Header/Header";
import Footer from "../Footer/Footer";
import PageHeading from "Components/PageHeading/PageHeading";
import AboutIntro from "./AboutIntro";
import OurSubjects from "./OurSubjects";
import ImageWithText from "./ImageWithText";

// Images
// import HeroImage from "../../Assets/Images/LandingPage/hero_image.png";
import TeachersPortalImg from "../../Assets/Images/AboutUs/teachers_portal_img.png";
import LeaderboardImg from "../../Assets/Images/AboutUs/Leaderboard_img.png";

// Import typography styles
import "../../Styles/typography.css";
import MobileHeader from "Components/Header/MobileHeader";


const AboutUs = () => {

	return (
		<AboutUsContainer className="">
			<Header />
			<MobileHeader />
			<PageHeading
				title={
					<>
						About <span className="redfont">Us</span>
					</>
				}
				breadcrumbs={[{ label: "Home", path: "/" }, { label: "About Us" }]}
			/>
			<AboutIntro />
			<OurSubjects />
			<div className="img_text_odd_even">
				<ImageWithText
					subheading="How It Works"
					title="Teachers'"
					highlight="Portal"
					description={[
						"Each question feeds directly into a fun competitive game where students can play anytime—solo, against classmates, or against the computer.",
						"Through the Teachers Portal, you can create custom study guide, generate questions using AI, or upload your own materials and the platform will do the rest.",
					]}
					boldIndex={1}
					buttonText="Request a Demo"
					buttonLink="/contact-us"
					image={TeachersPortalImg}
				/>

				<ImageWithText
					subheading=""
					title=""
					highlight="Leaderboard"
					description={[
						"With a live leaderboard, students stay motivated as they climb to the top, all while mastering the subject!",
						"Whether it’s quiz battles or multiplayer challenges, learning becomes interactive, exciting and effective",
					]}
					buttonText=""
					buttonLink=""
					reverse={true}
					image={LeaderboardImg}
				/>
			</div>
			<Footer />
		</AboutUsContainer>
	);
};

export default AboutUs;
